import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.inventoryTransaction',
    modules: [
        R,
    ],
})
@Service('InventoryTransactionStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('inventory_transactions');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/inventoryTransaction.js